const labels = {draft: 'Черновик', returned: 'На исправлении', submitted: 'Отправлен', approved: 'Утверждён',
    hr_editing: 'Правка табельщика', historical_locked: 'Архивный', pilot_closed: 'Пилот закрыт', annulled: 'Аннулирован'};
function statusLabel(status) { return labels[status] || status; }
function hoursLabel(minutes) {
    return minutes == null ? '—' : `${(Number(minutes) / 60).toLocaleString('ru-RU', {maximumFractionDigits: 3})} ч`;
}
function timesheetRoute(id, employeeId) {
    return {name: 'timesheet', params: {timesheetId: String(id)}, query: {focus_employee_id: String(employeeId)}};
}
module.exports = {statusLabel, hoursLabel, timesheetRoute};
